const columnsOnShelf = [
    {
        title: "排序",
        dataIndex: "list_order",
        key: "list_order",
        width: "100px",
        scopedSlots: {customRender: "list_order"}
    },
    {
        title: "编号",
        dataIndex: "code",
        width: "150px",
        ellipsis: true,
        key: "code"
    },
    {
        title: "缩略图",
        dataIndex: "thumb",
        ellipsis: true,
        width: "100px",
        key: "thumb",
        scopedSlots: {customRender: "thumb"}
    },
    {
        title: "模板地址",
        dataIndex: "template_url",
        ellipsis: true,
        width: "180px",
        scopedSlots: {customRender: "template_url"},
        key: "template_url"
    },
    {
        title: "客户数",
        dataIndex: "customer_num",
        ellipsis: true,
        width: "100px",
        key: "customer_num"
    },
    {
        title: "颜色",
        dataIndex: "color_name",
        ellipsis: true,
        width: "90px",
        key: "color_name"
    },
    {
        title: "行业",
        dataIndex: "industry_name",
        width: "130px",
        ellipsis: true,
        key: "industry_name"
    },
    {
        title: "设计师",
        dataIndex: "designer_name",
        width: "100px",
        ellipsis: true,
        key: "designer_name"
    },
    {
        title: "更新时间",
        dataIndex: "update_time",
        width: "150px",
        ellipsis: true,
        key: "update_time"
    },
    // {
    //     title: "代理模板",
    //     key: "is_proxy",
    //     width: "90px",
    //     dataIndex: "is_proxy",
    //     scopedSlots: {customRender: "is_proxy"}
    // },
    {
        title: "导航类型",
        dataIndex: "nav_type_text",
        width: "90px",
        ellipsis: true,
        key: "nav_type_text"
    },
    {
        title: "操作",
        key: "action",
        width: "200px",
        scopedSlots: {customRender: "action"}
    }
]

export default columnsOnShelf
